import type { TranslationTree } from '../../types';

export const signals: TranslationTree = {
  signals: {
    nav: 'Signaux',
    page: {
      breadcrumb: 'Visualisation des signaux',
      title: 'Visualisation des signaux',
      description:
        'Récupérez et explorez les signaux bruts InfluxDB pour n\'importe quelle machine, sur une plage temporelle libre — sans prédiction.',
    },
    source: {
      label: 'Source des signaux',
      tags: {
        active: 'active',
        activeAt: 'active · {{time}}',
        historyOnly: 'historique seulement',
        notFound: 'absente de la base',
        linkedTo: 'liée à {{machine}}',
        noSource: 'aucune source',
      },
    },
    panel: {
      badge: 'Contexte',
      machineLabel: 'Machine',
      machinePlaceholder: 'Sélectionner une machine',
      unlinkedSources: 'Sources sans machine (admins)',
      noSignalSource:
        "Cette machine n'a pas de source de signaux, il n'y a donc rien à afficher. Liez-en une dans Atelier → Machines.",
      machineStatus: {
        lastActivity: 'Dernière activité : {{date}}',
        noData: 'Aucune donnée pour cette machine',
      },
      signalsLabel: 'Signaux',
      signalsCounter: '{{count}} / {{max}} sélectionnés',
      signalsEmptyMachine: 'Sélectionnez une machine pour voir les signaux disponibles',
      signalsLoading: 'Chargement des signaux…',
      groups: {
        spindle: 'Broche',
        x: 'Axe X',
        y: 'Axe Y',
        z: 'Axe Z',
        b: 'Axe B',
        c: 'Axe C',
        lubrication: 'Lubrification',
        other: 'Autres',
      },
      timeRangeLabel: 'Plage temporelle',
      chips: {
        '15m': '15 min',
        '1h': '1 h',
        '8h': '8 h',
        '24h': '24 h',
        '7d': '7 j',
        custom: 'Personnalisé',
      },
      customStartLabel: 'Début',
      customEndLabel: 'Fin',
      lastActivityShortcut: 'Dernière activité (1 h)',
      rangeError: {
        invalid: 'Dates invalides.',
        order: 'La date de fin doit être après la date de début.',
        tooLong: 'La plage ne peut pas dépasser 90 jours.',
      },
      toolIdLabel: 'Outil (optionnel)',
      toolIdPlaceholder: 'ID outil',
      loadButton: 'Charger les signaux',
    },
    tags: {
      spindlePwr: 'Puissance broche',
      xFollErr: 'Erreur de poursuite X',
      yFollErr: 'Erreur de poursuite Y',
      zFollErr: 'Erreur de poursuite Z',
    },
    chart: {
      badge: 'Signaux',
      helper: '{{visible}} canal/canaux sur {{total}} · {{samples}} échantillons · {{passes}} passes',
      helperAggregated: '{{visible}} canal/canaux sur {{total}} · fenêtre {{window}} ms · {{samples}} pts',
      viewStack: 'Empilé',
      viewOverlay: 'Superposé',
      viewLabel: 'Disposition des courbes',
      peak: 'pic {{value}}',
      timeAxisLabel: 'Temps (s)',
      chipsGroupLabel: 'Afficher/masquer les canaux',
      passLabel: 'passe {{passIndex}}',
      errorTitle: 'Signal indisponible',
      errorRetry: 'Réessayer',
      emptyWindowTitle: 'Aucune donnée sur cette période',
      emptyWindowHint:
        'Cette machine n\'a aucun signal sur la période sélectionnée. Essayez le raccourci « Dernière activité » du panneau pour accéder à ses données les plus récentes.',
    },
    empty: {
      title: 'Choisissez une machine puis chargez les signaux',
      description: 'Sélectionnez une machine et une plage temporelle, puis cliquez sur Charger les signaux.',
    },
  },
};
